import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchTemplate(appId, pieceType) {
  const docId = String(pieceType).replace(/[^a-zA-Z0-9_]/g, '_').slice(0, 80);
  const templateRef = doc(db, 'artifacts', appId, 'public', 'data', 'office_custom_templates', docId);
  const snap = await getDoc(templateRef);
  return snap.exists() ? snap.data() || {} : null;
}

export async function saveTemplate(aid, pieceType, checklist, slotNames, email) {
  const docId = String(pieceType).replace(/[^a-zA-Z0-9_]/g, '_').slice(0, 80);
  const templateRef = doc(db, 'artifacts', aid, 'public', 'data', 'office_custom_templates', docId);
  await setDoc(templateRef, {
    pieceType,
    checklist_override: checklist,
    slotNames_override: slotNames || {},
    modified_by_email: email,
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
